export const invoicePlaceholders = [
  "{{CompanyName}}",
  "{{CompanyAddress}}",
  "{{CompanyGSTIN}}",
  "{{CustomerName}}",
  "{{CustomerAddress}}",
  "{{CustomerGSTIN}}",
  "{{InvoiceNo}}",
  "{{InvoiceDate}}",
  "{{PaymentMode}}",
  "{{Subtotal}}",
  "{{CGST}}",
  "{{SGST}}",
  "{{IGST}}",
  "{{GrandTotal}}",
  "{{AmountInWords}}",
];
